/* eslint-disable no-empty-pattern */
/*
 * @Description: ''
 * @Author: your name
 * @Date: 2021-04-28 09:24:23
 * @LastEditTime: 2021-05-06 17:18:08
 */

import * as apis from './api'

// 初始化store对象
const state = {
  aaa: '',
}

// 异步操作放到action handler里
const actions = {
  // 搜索 列表
  async getQueryHotelDatalist({}, payload) {
    const res = await apis.getQueryHotelDatalist(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 详情
  async details({}, payload) {
    const res = await apis.details(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 新增
  async save({}, payload) {
    const res = await apis.save(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 修改酒店
  async update({}, payload) {
    const res = await apis.update(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 修改库存
  async updateStock({}, payload) {
    const res = await apis.updateStock(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 修改线下预约
  async updateReserve({}, payload) {
    const res = await apis.updateReserve(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 修改酒店状态
  async updateStatus({}, payload) {
    const res = await apis.updateStatus(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
}
// 根据commit更新store
const mutations = {}
const getters = {}
// 导出vuex模块
export default {
  // 模块开启命名空间
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}